'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import GrpRoleModalSvc from './modal/grpRoleModal.service.js';

export default angular.module('georgeApp.grpRole', [uiRouter])
  .factory('GrpRoleModalSvc', GrpRoleModalSvc)
  .name;
